import { showToastMessage } from '../../../utils/AppUtils';

export const REFERRAL_SHARE_EMAIL_SUBJECT = 'Join me on BuzzBridge';

export function referralShareEmailBody(referralLink: string): string {
    return `Hey!\n\nJoin BuzzBridge with my referral link and we both earn rewards:\n\n${referralLink}\n\nSee you there!`;
}

export async function copyReferralLink(referralLink: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(referralLink);
        showToastMessage('Referral link copied', 'success');
        return true;
    } catch {
        showToastMessage('Could not copy link', 'error');
        return false;
    }
}

export function openReferralEmailShare(referralLink: string): void {
    const subject = encodeURIComponent(REFERRAL_SHARE_EMAIL_SUBJECT);
    const body = encodeURIComponent(referralShareEmailBody(referralLink));
    window.open(`mailto:?subject=${subject}&body=${body}`, '_self');
}
